import React, { useRef, useState } from 'react';
import './CartLogin.scss';
import CartIcon from '../../../assets/images/cart.svg';
import { useOnClickOutside } from '../../../../../js/custom-hooks/useOutsideClick';
import AccountDropdown from '../account-dropdown/AccountDropdown';
import { isMobile, isTablet } from 'react-device-detect';
const CartLogin = ({ count, user, improfileuser, profileuser }) => {
  const signInContainerRef = useRef();
  const [showSignInMenu, setShowSignInMenu] = useState(false);
  useOnClickOutside(signInContainerRef, () => setShowSignInMenu(false));
  const CartCount = ({ count }) => {
    return (
      <div className="cart-container">
        {count > 0 && <span className="cart-count-badge">{count}</span>}
      </div>
    );
  };

  function shortenText(text) {
    if (!text) return '';
    return text.length > 4 ? text.slice(0, 4) + '...' : text;
  }

  return (
    <div className="cart-login-container">
      <a className="cart-btn" href="/shopping-cart">
        <CartCount count={count} />
        <img
          width={16}
          height={16}
          src={CartIcon}
          //   className="custom-logo"
          alt="Trinity Consultants logo"
        />
      </a>
      <span className="divider"></span>
      {!user && (
        <a href="/login" className="login-link">
          Sign In
        </a>
      )}
      <p className="sign-in" onClick={() => setShowSignInMenu(!showSignInMenu)}>
        {' '}
        {isMobile
          ? shortenText(
              !user
                ? ''
                : improfileuser
                ? 'Hello, ' + improfileuser.FirstName
                : profileuser
                ? 'Hello, ' + profileuser.FirstName
                : ''
            )
          : !user
          ? ''
          : improfileuser
          ? 'Hello, ' + improfileuser.FirstName
          : profileuser
          ? 'Hello, ' + profileuser.FirstName
          : ''}
        {user && <i className="fa fa-angle-down" />}
      </p>
      <AccountDropdown
        showSignInMenu={showSignInMenu}
        setShowSignInMenu={setShowSignInMenu}
        user={user}
      />
    </div>
  );
};

export default CartLogin;
